var _rect, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailNotificationSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 8,
    fill: "#E6F4E8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.9997,
    cy: 26,
    r: 7.50312,
    stroke: "#098E1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0352 26.2826L24.8417 28.0892L24.8301 28.0775L28.9059 24.0017",
    stroke: "#098E1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailNotificationSuccess);
export default __webpack_public_path__ + "static/media/mail-notification-success.94756720d240074538d78f4d73bac2bd.svg";
export { ForwardRef as ReactComponent };